@if (options && widgets && widgets.length > 0) {
<div
  class="d-flex align-items-center justify-content-center"
  style="height: 1200px; width: 100%"
>
  <gridster [options]="options">
    @for (widget of widgets; track $index) {
    <gridster-item [item]="widget">
      <ng-container
        *ngComponentOutlet="
          widget.component;
          inputs: { widgetData: widget.data }
        "
      >
      </ng-container>
    </gridster-item>
    }
  </gridster>
</div>
}@else {
<div class="col-12">
  <div class="text-center p-5 bg-white rounded-3">
    <i class="fas fa-chart-pie fa-3x text-muted mb-3"></i>
    <h3 class="text-muted">
      {{ "gridsterWidgetsComponent.noWidgets" | translate }}
    </h3>
    <p class="text-muted">
      {{ "gridsterWidgetsComponent.noWidgetsInfo" | translate }}
    </p>
  </div>
</div>

}
